import type { layout } from "@app/domain";
import { gameOf } from "../variants";
import type { AnyView } from "../variants/types";
import type { PassChoice } from "./passChoice";

/** Your panel when the move is yours; which one is the game's business (variants/). */
export function TurnPanel({
  view,
  names,
  measure,
  pass = null,
}: {
  view: AnyView;
  names: (string | null)[];
  measure: layout.Measure;
  pass?: PassChoice | null;
}) {
  const { Panel } = gameOf(view);
  return <Panel view={view} names={names} narrow={measure.state === "portrait"} pass={pass} />;
}
